export function animation(callback, interval) {
  let requestId = 0;

  const cancelAnimationFrame =
    window.cancelAnimationFrame || window.mozCancelAnimationFrame;

  function start() {
    let then = performance.now();
    function animate(now) {
      requestId = window.requestAnimationFrame(animate);

      const delta = now - then;

      if (delta >= interval) {
        then = now - (delta % interval);
        callback();
      }
    }

    requestId = window.requestAnimationFrame(animate);
  }

  function stop() {
    cancelAnimationFrame(requestId);
    requestId = 0;
  }

  function isRunning() {
    return Boolean(requestId);
  }

  return { start, stop, isRunning };
}
